import { Box, Card, Separator, Shimmer, ShimmerText } from '@betterment/samba-react';

const TITLE_WIDTH = '20%';
const HEADER_WIDTH = '40%';
const LINK_WIDTH = '40%';
const ICON_SIZE = '40px';

const ShimmerRow = () => {
  return (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: `${ICON_SIZE} 1fr`,
        gap: 'space.200',
        alignItems: 'start',
      }}
    >
      <Box
        css={{
          gridRow: '1 / -1',
          width: ICON_SIZE,
          height: ICON_SIZE,
          alignSelf: 'center',
        }}
      >
        <Shimmer css={{ width: ICON_SIZE, height: ICON_SIZE, borderRadius: 'round' }} />
      </Box>
      <Box
        css={{
          gridColumn: 2,
          gridRow: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 'space.25',
          alignSelf: 'center',
        }}
      >
        <ShimmerText textStyle="text100" css={{ maxWidth: HEADER_WIDTH }} />
      </Box>
      <Box css={{ gridColumn: 2, gridRow: 2, display: 'flex', flexDirection: 'column', gap: 'space.50' }}>
        <ShimmerText textStyle="text25" />
        <ShimmerText textStyle="text25" css={{ maxWidth: '25%' }} />
      </Box>
    </Box>
  );
};

export const HowToSaveCardLoadingState = () => {
  return (
    <Card css={{ position: 'relative' }} role="status" aria-label="Loading...">
      <Card.Content css={{ display: 'flex', flexDirection: 'column', padding: 'space.300', gap: 'space.300' }}>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.200' }}>
          <ShimmerText textStyle="title200" css={{ maxWidth: TITLE_WIDTH }} />
          <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.50' }}>
            <ShimmerText textStyle="text25" />
            <ShimmerText textStyle="text25" />
            <ShimmerText textStyle="text25" css={{ maxWidth: '25%' }} />
          </Box>
        </Box>

        <Separator />
        <ShimmerRow />
        <Separator />
        <ShimmerRow />
        <Separator />

        <ShimmerText textStyle="text25" css={{ maxWidth: LINK_WIDTH }} />
      </Card.Content>
    </Card>
  );
};
